(function($) {
        $('body').on('click', '.image-crop-init', function () {
            $('#img-crop').cropper('destroy');

            $('#img-crop').cropper({
                 aspectRatio: 4/3,
		dragMode: 'move',
                crop: function (e) {
                },

            });
        });

        $('body').on('click', '.image-crop-destroy', function () {
            $('#img-crop').cropper('destroy');
        });

        $('body').on('click', '.image-crop-save', function () {
            var dimData = $('#img-crop').cropper('getData');
            var imData = $('#img-crop').cropper('getImageData');


            var cropData = {
                imageId: $('#img-crop').attr('data-image-id'),
                x: dimData.x,
                y: dimData.y,
                width: dimData.width,
                height: dimData.height,
		wo: imData.naturalWidth,
		ho: imData.naturalHeight,
		wn: imData.width,
		hn: imData.height
            };

            $.post( "/api/avatars/crops", cropData)
                .done(function( response ) {
                    $('.btn-form-save').trigger('click');
                });
        });

})(jQuery);
